var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "expand_more",
  "use": "expand_more-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"expand_more\"><path d=\"M0 0h24v24H0z\" fill=\"none\" /><path d=\"M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol